import { type IconProps } from '../iconProps';

export const LaptopMinimal: React.FC<IconProps> = ({
  size = 24,
  fill = '',
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill={fill}
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      className='lucide lucide-laptop-minimal-icon lucide-laptop-minimal'
    >
      <rect
        width='18'
        height='12'
        x='3'
        y='4'
        rx='2'
        ry='2'
      />
      <line
        x1='2'
        x2='22'
        y1='20'
        y2='20'
      />
    </svg>
  );
};
